import { isEmpty, isEqual, pick } from 'lodash';
import { getTranslatedText, useIntl } from '@nile/components';

const getChartData = (updatedData, chartId) => {
  return updatedData.charts.find((el) => el.chartId === chartId);
};

const reportObjFormatter = (dataToMap) => {
  const intl = useIntl();

  let dataLayout = dataToMap?.layout?.layout || null;

  if (!isEmpty(dataToMap.charts)) {
    dataLayout = dataToMap.layout.layout.map((el) => ({
      ...el,
      chart: el?.chart && getChartData(dataToMap, el.chart.chartId)
    }));
  }

  return {
    reportId: dataToMap?.reportId || null,
    name:
      dataToMap?.name ||
      getTranslatedText(intl, 'reports.dashboard.name.untitled'),
    description:
      dataToMap?.description ||
      getTranslatedText(intl, 'reports.dashboard.description.untitled'),
    layout: dataLayout,
    internalName: dataToMap.internalName,
    charts: dataToMap?.charts || [],
    addCharts: [],
    deleteCharts: [],
    parentCharts: dataToMap?.parentCharts || dataToMap?.charts || [],
    reportType: dataToMap?.reportType || null,
    reportConfig: dataToMap?.reportConfig || null,
    fullScreenModeEnabled: dataToMap?.fullScreenModeEnabled || false,
    fullScreenModeRefreshInterval:
      dataToMap?.fullScreenModeRefreshInterval || null
  };
};

const dataToCheck = ['name', 'description'];

const isReportSaved = (actual, edited) => {
  const oldData = {
    ...pick(actual, dataToCheck),
    layout:
      (actual.layout &&
        actual.layout.map((el) => pick(el, ['i', 'w', 'h', 'x', 'y']))) ||
      []
  };
  const newData = {
    ...pick(edited, dataToCheck),
    layout:
      (edited.layout &&
        edited.layout.map((el) => pick(el, ['i', 'w', 'h', 'x', 'y']))) ||
      []
  };
  return isEqual(oldData, newData);
};

export { reportObjFormatter, isReportSaved };
